import React from 'react';
import { View } from 'react-native';
import tw from '../../utils/Tailwind';

export default function Container({ children, style = null }) {
  return <View style={[tw`px-4`, style]}>{children}</View>;
}
